import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IFilePreviewSplitPanelState } from "./definitions";

const initialState: IFilePreviewSplitPanelState = {
  selectedDocumentId: null,
  isOpen: false,
  gaiaObjectType: undefined,
};

export const filePreviewSplitPanelSlice = createSlice({
  name: "filePreviewSplitPanel",
  initialState,
  reducers: {
    setSelectedDocumentId: (state, action: PayloadAction<string | null>) => {
      state.selectedDocumentId = action.payload;
    },
    setSplitPanelOpen: (state, action: PayloadAction<boolean>) => {
      state.isOpen = action.payload;
    },
    setGaiaObjectType: (state, action: PayloadAction<string | undefined>) => {
      state.gaiaObjectType = action.payload;
    },
  },
});

export const { setSelectedDocumentId, setSplitPanelOpen, setGaiaObjectType } =
  filePreviewSplitPanelSlice.actions;

export default filePreviewSplitPanelSlice.reducer;
